export default {
	title: 'Éléments désactivés',
	empty: 'Aucun élément désactivé dans ce scénario',
	no_scenario: 'Sélectionnez un scénario pour voir les éléments désactivés'
};

